import { useState } from "react";
import { IUser } from "../../type";
import { updateUser } from "../../api/user";
import { AvatarEdit } from "./avatarEdit";
import { NameEdit } from "./NameEdit";
import { EmailEdit } from "./emailEdit";
import { BirthdateEdit } from "./birthdateEdit";
import { CityEdit } from "./cityEdit";
import { AboutEdit } from "./aboutEdit";
import { useNavigate } from "react-router-dom";

interface IUserTMP {
  name?: string;
  phone?: string;
  email?: string;
  birthdate?: Date;
  city?: string;
  about?: string;
  avatarLink?: string;
}

interface IProps {
  user: IUser;
  relogin: () => void;
}

export function ProfileEdit(props: IProps) {
  const [user, setUser] = useState<IUserTMP>({});
  const [pageEdPr, setPageEdPr] = useState<number>(0);
  const nav = useNavigate();

  const onclick = () => {
    setPageEdPr(pageEdPr + 1);
  };
  const onclick1 = (n: string) => {
    setPageEdPr(pageEdPr + 1);
    setUser({ ...user, name: n });
  };
  const onclick2 = (em: string) => {
    setPageEdPr(pageEdPr + 1);
    setUser({ ...user, email: em });
  };
  const onclick3 = (ph: Date) => {
    setPageEdPr(pageEdPr + 1);
    setUser({ ...user, birthdate: ph });
  };
  const onclick4 = (c: string) => {
    setPageEdPr(pageEdPr + 1);
    setUser({ ...user, city: c });
  };
  const onclick5 = (e: string) => {
    updateUser({ ...user, about: e } as IUser).then((r) => {
      props.relogin();
      nav("/profile");
    });
  };
  const leftBtnBack = () => {
    setPageEdPr(pageEdPr - 1);
  };

  return (
    <section className="section mainPage flex flex-column sectionUser profileEditPage">
      <div className="progressBar">
        {[0, 1, 2, 3, 4, 5].map((p, index) => {
          let cls = "";
          if (index <= pageEdPr) {
            cls = "active";
          }
          return <div className={cls} key={index} />;
        })}
      </div>
      {pageEdPr === 0 ? (
        <AvatarEdit
          onclkbtn={onclick}
          user={{ ...props.user, ...user } as IUser}
          onAvatarUpdated={(u) => setUser((prev) => ({ ...prev, avatarLink: u.avatarLink }))}
        />
      ) : pageEdPr === 1 ? (
        <NameEdit onClickRight={onclick1} user={props.user} onClickLeft={leftBtnBack}/>
      ) : pageEdPr === 2 ? (
        <EmailEdit onClickRight={onclick2} user={props.user} onClickLeft={leftBtnBack} />
      ) : pageEdPr === 3 ? (
        <BirthdateEdit onClickRight={onclick3} user={props.user} onClickLeft={leftBtnBack} />
      ) : pageEdPr === 4 ? (
        <CityEdit onClickRight={onclick4} user={props.user} onClickLeft={leftBtnBack} />
      ) : pageEdPr === 5 ? (
        <AboutEdit onClickRight={onclick5} user={props.user} onClickLeft={leftBtnBack} />
      ) : (
        ""
      )}
    </section>
  );
}
